import { render, staticRenderFns } from "./RegisterLabel.vue?vue&type=template&id=029d472e&"
import script from "./RegisterLabel.vue?vue&type=script&lang=js&"
export * from "./RegisterLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports